import {switchMap} from "rxjs/operators";
import {ofType} from "redux-observable";

import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";

const logInAction = (action$) =>
    action$.pipe(
        ofType(actionTypes.LOG_IN),
        switchMap(({payload}) => {
            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_LOG_IN,
                        params: {
                            login: payload.login,
                            password: payload.password
                        }
                    },
                    method: handlers.LOG_IN,
                    tabId: 0
                }
            ];
        })
    );

export default [logInAction];
